import { useLayoutEffect, useRef } from 'react'

import UIIcon from '@/components/UI/UIIcon'
import { useGSAP } from '@/composables/useGSAP'

export type RunnerGoalInvertLettersItemCollectedProps = {
  item: {
    text: string
    replacement?: { goal: string; inverted: string }
  }
}

export default function RunnerGoalInvertLettersItemCollected({ item }: RunnerGoalInvertLettersItemCollectedProps) {
  const { gsap } = useGSAP()
  const iconRef = useRef<SVGSVGElement>(null)

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap
        .timeline()
        .fromTo(
          iconRef.current,
          { scale: 0.5, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.5, ease: 'back.out(1.7)' }
        )
    })

    return () => ctx.revert()
  }, [iconRef, gsap])

  return (
    <span className='inline-block relative px-10'>
      <UIIcon
        ref={iconRef}
        icon='background1'
        className='z-1 mt-3 text-mid-blue absolute top-1/2 left-1/2 w-40 h-40 -translate-x-1/2 -translate-y-1/2'
      />
      <span className='relative text-cream z-2'>{item.text}</span>
    </span>
  )
}
